/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientTicketDto } from '../../models/client-ticket-dto';
import { CreateClientTicketDto } from '../../models/create-client-ticket-dto';

export interface ClientTicketControllerCreate$Params {
  clientWorkspaceId: string;
  vendorWorkspaceId: string;
      body: CreateClientTicketDto
}

export function clientTicketControllerCreate(http: HttpClient, rootUrl: string, params: ClientTicketControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketDto>> {
  const rb = new RequestBuilder(rootUrl, clientTicketControllerCreate.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('vendorWorkspaceId', params.vendorWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientTicketDto>;
    })
  );
}

clientTicketControllerCreate.PATH = '/api/client-ticket/{clientWorkspaceId}/{vendorWorkspaceId}';
